<template>
  <div class="docs">
    <div class="col-md-12 jumbotron my-3 p-3">
      <div class="row col-md-12 m-0 p-0">
        <div class="col-md-6 m-0 p-0 text-left">
          <p class=""><strong>Driving License</strong></p>
        </div>
        <div class="col-md-6 m-0 p-0 text-left">
          <p class=""><strong>ID Proof - <span v-if="customer.IDtype" class="badge badge-info">{{customer.IDtype}}</span>
          <span v-else class="badge badge-danger">Not Defined</span>
          </strong></p>
        </div>
        <div class="col-md-6 m-0 p-0">
          <p>
            <strong
              >DL Status -
              <span v-if="customer.DLVerified == 1" class="badge badge-success"
                >Verified
                <button
                  @click="verifyDL(0)"
                  style="font-size:12px"
                  class="btn btn-danger m-0 ml-1 px-1 p-0"
                >
                  Disapprove
                </button>
              </span>
              <span v-else class="badge badge-danger"
                >Not Verified
                <button
                  @click="verifyDL(1)"
                  style="font-size:12px"
                  class="btn btn-success m-0 ml-1 px-1 p-0"
                >
                  Approve
                </button>
              </span>
            </strong>
          </p>
          <div class="row col-md-12 m-0 p-0">
            <div class="col-md-6 text-center m-0 pl-1">
              <img ref="dlfront" id="img1" @click="openImage(customer.DLfront)" v-if="customer.DLfront" :src="customer.DLfront" width="100%" alt="" />
              <img  v-else width="100%" src="https://icon-library.com/images/no-image-icon/no-image-icon-1.jpg" alt="">
              
              <button
                
                style="font-size:12px"
                class="btn btn-info m-0 px-1 my-2 p-0"
                id="fileInputButton"
                onclick="document.getElementById('fileDlFront').click()"
              >
                Change
              </button>
              <input type="file" id="fileDlFront" style="display:none" @change="onFileChangeDLfront">
            </div>
            <div class="col-md-6 m-0 pr-1 text-center">
              <img @click="openImage(customer.DLback)" v-if="customer.DLback" :src="customer.DLback" width="100%" alt="" />
              <img  v-else width="100%" src="https://icon-library.com/images/no-image-icon/no-image-icon-1.jpg" alt="">
              <button
                style="font-size:12px"
                class="btn btn-info m-0 px-1 my-2 p-0"
                id="fileInputButton"
                onclick="document.getElementById('fileInput').click()"
              >
                Change
              </button>
              <input type="file" id="fileInput" style="display:none" @change="onFileChange">
            </div>
          </div>
        </div>
        <div class="col-md-6 m-0 p-0">
          <p class="">
            <strong
              >ID Status -
              <span v-if="customer.IDVerified == 1" class="badge badge-success"
                >Verified
                <button
                  @click="verifyID(0)"
                  style="font-size:12px"
                  class="btn btn-danger m-0 ml-1 px-1 p-0"
                >
                  Disapprove
                </button>
              </span>
              <span v-else class="badge badge-danger"
                >Not Verified
                <button
                  @click="verifyID(1)"
                  style="font-size:12px"
                  class="btn btn-success m-0 ml-1 px-1 p-0"
                >
                  Approve
                </button>
              </span>
            </strong>
          </p>
          <!-- <button @click="loadExif">Load EXIF File</button> -->
          <div class="row col-md-12 m-0 p-0">
            <div class="col-md-6 text-center m-0 pl-1">
              <img @click="openImage(customer.idProof)" v-if="customer.idProof" :src="customer.idProof" width="100%" alt="" />
              <img  v-else width="100%" src="https://icon-library.com/images/no-image-icon/no-image-icon-1.jpg" alt="">

              <button
                style="font-size:12px"
                class="btn btn-info m-0 px-1 my-2 p-0"
                id="fileInputButton"
                onclick="document.getElementById('fileInputIdFront').click()"
              >
                Change
              </button>
              <input type="file" id="fileInputIdFront" style="display:none" @change="onFileChangeIdFront">
            </div>
            <div class="col-md-6 m-0 pr-1 text-center">
              <img @click="openImage(customer.idProofBack)" v-if="customer.idProofBack" :src="customer.idProofBack" width="100%" alt="" />
              <img  v-else width="100%" src="https://icon-library.com/images/no-image-icon/no-image-icon-1.jpg" alt="">

              <button
                style="font-size:12px"
                class="btn btn-info m-0 px-1 my-2 p-0"
                id="fileInputButton"
                onclick="document.getElementById('fileIdBack').click()"
              >
                Change
              </button>
              <input type="file" id="fileIdBack" style="display:none" @change="onFileChangeIdBack">
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 mt-4 m-0 p-0">
        <p class="m-0 p-0">DL Number</p>
        <input type="text" v-model="DLnumber" />
        <button @click="updateDL()" style="font-size:12px" class="btn btn-secondary ml-2">Update</button>
        <p class="mt-3 m-0 p-0">
          DL Number Status-
          <span
            v-if="customer.DLnumberVerified == 1"
            class="badge badge-success"
            >Verified
            <button
              @click="verifyDLNumber(0)"
              style="font-size:12px"
              class="btn btn-danger m-0 ml-1 px-1 p-0"
            >
              Disapprove
            </button>
          </span>
          <span v-else class="badge badge-danger"
            >Not Verified
            <button
              @click="verifyDLNumber(1)"
              style="font-size:12px"
              class="btn btn-success m-0 ml-1 px-1 p-0"
            >
              Approve
            </button>
          </span>
        </p>
      </div>
      <div class="mt-5 col-md-12 text-center" v-if="customer.length == 0 && !makingAJAX">
        <p>We didn't get any data.</p>
      </div>
    </div>
  </div>
</template>

<script>
const axios = require("axios");
export default {
  data() {
    return {
      cx_id: "",
      DLnumber: 0,
      makeAndModel: ''
    };
  },
  watch: {
    customer() {
      this.DLnumber = this.customer.DLnumber;
      console.log(this.customer.DLfront)
    },
  },
  created() {
    this.cx_id = this.$route.params.cx_id;
    this.$store.dispatch("get_customerData", { id: this.cx_id });
  },
  mounted () {},
  computed: {
    makingAJAX(){
      return this.$store.state.makingAJAX
    },
    customer() {
      return this.$store.state.customer_data;
    },
  },
  methods: {
    openImage(url){
      window.open(url, "_blank"); 
    },
    onFileChange(e) {
      const file = e.target.files[0];
      const image1=event.target.files[0];
      const url = URL.createObjectURL(file);
      console.log(url)
      const fd = new FormData
      fd.append('image', image1)
      axios
        .post(
          "https://api.on-track.in/api/uploadCustomerDoc?id="+this.cx_id+"&key=DLback",
          fd,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Basic YWRtaW5BdXRoOnZpc2h1QDE5OTI=",
            },
          }
        )
        .then(() => {
          this.$toasted.show("Done", {
            type: "success",
            position: "bottom-center",
            duration: 1000,
            theme: "bubble",
          });
          this.$store.dispatch("get_customerData", { id: this.cx_id });
        })
        .catch(() => {
          this.$toasted.global.my_app_error();
        });
    },
    onFileChangeDLfront(e) {
      const file = e.target.files[0];
      const image1=event.target.files[0];
      const url = URL.createObjectURL(file);
      console.log(url)
      const fd = new FormData
      fd.append('image', image1)
      axios
        .post(
          "https://api.on-track.in/api/uploadCustomerDoc?id="+this.cx_id+"&key=DLfront",
          fd,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Basic YWRtaW5BdXRoOnZpc2h1QDE5OTI=",
            },
          }
        )
        .then(() => {
          this.$toasted.show("Done", {
            type: "success",
            position: "bottom-center",
            duration: 1000,
            theme: "bubble",
          });
          this.$store.dispatch("get_customerData", { id: this.cx_id });
        })
        .catch(() => {
          this.$toasted.global.my_app_error();
        });
    },
    onFileChangeIdFront(e) {
      const file = e.target.files[0];
      const image1=event.target.files[0];
      const url = URL.createObjectURL(file);
      console.log(url)
      const fd = new FormData
      fd.append('image', image1)
      axios
        .post(
          "https://api.on-track.in/api/uploadCustomerDoc?id="+this.cx_id+"&key=idProof",
          fd,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Basic YWRtaW5BdXRoOnZpc2h1QDE5OTI=",
            },
          }
        )
        .then(() => {
          this.$toasted.show("Done", {
            type: "success",
            position: "bottom-center",
            duration: 1000,
            theme: "bubble",
          });
          this.$store.dispatch("get_customerData", { id: this.cx_id });
        })
        .catch(() => {
          this.$toasted.global.my_app_error();
        });
    },
    onFileChangeIdBack(e) {
      const file = e.target.files[0];
      const image1=event.target.files[0];
      const url = URL.createObjectURL(file);
      console.log(url)
      const fd = new FormData
      fd.append('image', image1)
      axios
        .post(
          "https://api.on-track.in/api/uploadCustomerDoc?id="+this.cx_id+"&key=idProofBack",
          fd,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Basic YWRtaW5BdXRoOnZpc2h1QDE5OTI=",
            },
          }
        )
        .then(() => {
          this.$toasted.show("Done", {
            type: "success",
            position: "bottom-center",
            duration: 1000,
            theme: "bubble",
          });
          this.$store.dispatch("get_customerData", { id: this.cx_id });
        })
        .catch(() => {
          this.$toasted.global.my_app_error();
        });
    },
    verifyDLNumber(state) {
      axios
        .post(
          "https://api.on-track.in/api/customer/" + this.cx_id,
          {
            DLnumberVerified: state,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Basic YWRtaW5BdXRoOnZpc2h1QDE5OTI=",
            },
          }
        )
        .then(() => {
          this.$toasted.show("Done", {
            type: "success",
            position: "bottom-center",
            duration: 1000,
            theme: "bubble",
          });
          this.$store.dispatch("get_customerData", { id: this.cx_id });
        })
        .catch(() => {
          this.$toasted.global.my_app_error();
        });
    },
     verifyDL(state) {
      axios
        .post(
          "https://api.on-track.in/api/customer/" + this.cx_id,
          {
            DLVerified: state,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Basic YWRtaW5BdXRoOnZpc2h1QDE5OTI=",
            },
          }
        )
        .then(() => {
          this.$toasted.show("Done", {
            type: "success",
            position: "bottom-center",
            duration: 1000,
            theme: "bubble",
          });
          this.$store.dispatch("get_customerData", { id: this.cx_id });
        })
        .catch(() => {
          this.$toasted.global.my_app_error();
        });
    },
     verifyID(state) {
      axios
        .post(
          "https://api.on-track.in/api/customer/" + this.cx_id,
          {
            IDVerified: state,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Basic YWRtaW5BdXRoOnZpc2h1QDE5OTI=",
            },
          }
        )
        .then(() => {
          this.$toasted.show("Done", {
            type: "success",
            position: "bottom-center",
            duration: 1000,
            theme: "bubble",
          });
          this.$store.dispatch("get_customerData", { id: this.cx_id });
        })
        .catch(() => {
          this.$toasted.global.my_app_error();
        });
    },
    updateDL() {
      axios
        .post(
          "https://api.on-track.in/api/customer/" + this.cx_id,
          {
            DLnumber: this.DLnumber,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Basic YWRtaW5BdXRoOnZpc2h1QDE5OTI=",
            },
          }
        )
        .then(() => {
          this.$toasted.show("Done", {
            type: "success",
            position: "bottom-center",
            duration: 1000,
            theme: "bubble",
          });
          this.$store.dispatch("get_customerData", { id: this.cx_id });
        })
        .catch(() => {
          this.$toasted.global.my_app_error();
        });
    },
  },
};
</script>

<style></style>
